import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'shortEmail',
    standalone: false
})
export class ShortEmailPipe implements PipeTransform {

  transform(value: string): string {
    
    if(value.length > 23) {
      return value.substring(0, 22) + "...";
    }
    return value;
  }

}
